/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddWalletRequestBody
 */
export interface AddWalletRequestBody {
    /**
     * 
     * @type {string}
     * @memberof AddWalletRequestBody
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof AddWalletRequestBody
     */
    publicKey: string;
}

/**
 * Check if a given object implements the AddWalletRequestBody interface.
 */
export function instanceOfAddWalletRequestBody(value: object): value is AddWalletRequestBody {
    if (!('signature' in value) || value['signature'] === undefined) return false;
    if (!('publicKey' in value) || value['publicKey'] === undefined) return false;
    return true;
}

export function AddWalletRequestBodyFromJSON(json: any): AddWalletRequestBody {
    return AddWalletRequestBodyFromJSONTyped(json, false);
}

export function AddWalletRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddWalletRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'signature': json['signature'],
        'publicKey': json['publicKey'],
    };
}

export function AddWalletRequestBodyToJSON(json: any): AddWalletRequestBody {
    return AddWalletRequestBodyToJSONTyped(json, false);
}

export function AddWalletRequestBodyToJSONTyped(value?: AddWalletRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signature': value['signature'],
        'publicKey': value['publicKey'],
    };
}

